///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import BidStatusTag from "../Bid/BidStatusTag";
import ErrorIcon from "../icons/ErrorIcon";
import messages from "../../helpers/messages";

export const BidInfo = ({ role, isManagement }) => {
  const { summary, summaryError, summaryLoading } = useSelector(
    state => state.bidSummary
  );

  return (
    <>
      {summary && (
        <>
          <h1
            data-testid="bid-name"
            className={`alpha-heading inline-block pr-20 truncate mb-12 ${
              isManagement ? "bid-title-short-width" : "bid-title"
            }`}
            title={summary.name}
          >
            {summary.name}
          </h1>
          <BidStatusTag summary={summary} role={role} />
        </>
      )}
      {summaryLoading && (
        <div
          data-testid="bid-name-spinner"
          className="content-placeholder mt-12 inline-block"
        >
          <span className="h-16" style={{ width: "462px" }}></span>
        </div>
      )}
      {summaryError && (
        <div className="inline-block" data-testid="bid-name-error">
          <ErrorIcon
            height="24px"
            width="24px"
            fill="#B00020"
            className="pos-relative bid-name-error-icon"
          />
          <span
            data-testid="error-message"
            className="pl-16 font-size-16 text-rfq-red"
          >
            {messages.pleaseRefreshTheBrowser.defaultMessage}
          </span>
        </div>
      )}
    </>
  );
};

export default BidInfo;
